<template>
  <div id="BenvenutoImg">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 427.679 386.145"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          y1="1"
          x2="0.5"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stop-color="#1123a5" />
          <stop offset="0.369" stop-color="#2a3ec7" />
          <stop offset="1" stop-color="#546cff" />
        </linearGradient>
        <filter
          id="Rettangolo_2"
          x="65.327"
          y="0"
          width="299.792"
          height="237.894"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="5" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3.5" result="blur" />
          <feFlood flood-color="#546cff" flood-opacity="0.502" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Tracciato_10"
          x="178.499"
          y="103.71"
          width="73.089"
          height="73.089"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="2.5" result="blur-2" />
          <feFlood flood-color="#546cff" flood-opacity="0.502" />
          <feComposite operator="in" in2="blur-2" />
          <feComposite in="SourceGraphic" />
        </filter>
        <linearGradient
          id="linear-gradient-2"
          y1="0.5"
          x2="1"
          y2="0.5"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stop-color="#ff8f00" />
          <stop offset="1" stop-color="#ffbd00" />
        </linearGradient>
        <filter
          id="Ellisse_1"
          x="188.149"
          y="113.361"
          width="53.788"
          height="53.788"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="2.5" result="blur-3" />
          <feFlood flood-color="#ff9c01" flood-opacity="0.502" />
          <feComposite operator="in" in2="blur-3" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Tracciato_11"
          x="197.388"
          y="122.642"
          width="37.143"
          height="33.524"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="2.5" result="blur-4" />
          <feFlood flood-color="#ff9d01" flood-opacity="0.502" />
          <feComposite operator="in" in2="blur-4" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Rettangolo_38"
          x="240.291"
          y="191.973"
          width="139.151"
          height="124.977"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="2.5" result="blur-5" />
          <feFlood flood-color="#546cff" flood-opacity="0.502" />
          <feComposite operator="in" in2="blur-5" />
          <feComposite in="SourceGraphic" />
        </filter>
        <linearGradient
          id="linear-gradient-3"
          x1="0.5"
          y1="1"
          x2="0.5"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stop-color="#6c9cff" />
          <stop offset="1" stop-color="#a4c4ff" />
        </linearGradient>
        <filter
          id="Ellisse_2"
          x="301.625"
          y="97.308"
          width="126.054"
          height="126.054"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="2.5" result="blur-6" />
          <feFlood flood-color="#546cff" flood-opacity="0.502" />
          <feComposite operator="in" in2="blur-6" />
          <feComposite in="SourceGraphic" />
        </filter>
        <linearGradient
          id="linear-gradient-4"
          x1="-0.049"
          y1="0.515"
          x2="0.951"
          y2="0.515"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stop-color="#aac8fd" />
          <stop offset="0.855" stop-color="#d4e4ff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-6"
          x1="0.5"
          y1="1"
          x2="0.5"
          y2="0"
          xlink:href="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-8"
          x1="0.5"
          y1="1"
          x2="0.5"
          y2="0"
          xlink:href="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-9"
          x1="0.5"
          y1="1"
          x2="0.5"
          y2="0"
          xlink:href="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-10"
          x1="0.5"
          y1="1"
          x2="0.5"
          y2="0"
          xlink:href="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-11"
          x1="0.5"
          y1="1"
          x2="0.5"
          y2="0"
          xlink:href="#linear-gradient-2"
        />
        <linearGradient
          id="linear-gradient-14"
          y1="16.016"
          y2="0"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-15"
          y1="1"
          y2="-15.017"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-16"
          x1="8.008"
          y1="30.408"
          x2="8.008"
          y2="-29.408"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-17"
          x1="-7.008"
          y1="30.408"
          x2="-7.008"
          y2="-29.408"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-18"
          x1="7.259"
          y1="17.45"
          x2="7.259"
          y2="-2.935"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-19"
          x1="-6.257"
          y1="3.936"
          x2="-6.257"
          y2="-16.454"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-20"
          x1="7.259"
          y1="3.936"
          x2="7.259"
          y2="-16.454"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-21"
          x1="-6.257"
          y1="17.45"
          x2="-6.257"
          y2="-2.935"
          xlink:href="#linear-gradient"
        />
        <linearGradient
          id="linear-gradient-22"
          x1="0.5"
          y1="1"
          x2="0.5"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stop-color="#7fa2de" />
          <stop offset="1" stop-color="#a3c1ff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-23"
          x1="0.5"
          y1="1"
          x2="0.5"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stop-color="#a3c1ff" />
          <stop offset="0.854" stop-color="#cbdeff" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-24"
          x1="0.5"
          y1="1"
          x2="0.5"
          y2="0"
          xlink:href="#linear-gradient-2"
        />
      </defs>
      <g id="Ordina" transform="translate(-34.777 -113.855)">
        <g id="Raggruppa_7" data-name="Raggruppa 7">
          <g
            transform="matrix(1, 0, 0, 1, 34.78, 113.86)"
            filter="url(#Rettangolo_2)"
          >
            <rect
              id="Rettangolo_2-2"
              data-name="Rettangolo 2"
              width="278.792"
              height="216.894"
              rx="23.315"
              transform="translate(75.83 5.5)"
              fill="url(#linear-gradient)"
            />
          </g>
          <path
            id="Tracciato_3"
            data-name="Tracciato 3"
            d="M366.083,119.355H197.621L389.4,297.01V142.667A23.312,23.312,0,0,0,366.083,119.355Z"
            fill="#fff"
            opacity="0.9"
            style="mix-blend-mode: soft-light; isolation: isolate"
          />
          <g id="Raggruppa_3" data-name="Raggruppa 3">
            <rect
              id="Rettangolo_3"
              data-name="Rettangolo 3"
              width="32.474"
              height="25.187"
              rx="2.333"
              transform="translate(126.87 181.445)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_4"
              data-name="Rettangolo 4"
              width="32.474"
              height="25.187"
              rx="2.333"
              transform="translate(162.501 181.445)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_5"
              data-name="Rettangolo 5"
              width="32.474"
              height="25.187"
              rx="2.333"
              transform="translate(198.132 181.445)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_6"
              data-name="Rettangolo 6"
              width="32.474"
              height="25.187"
              rx="2.333"
              transform="translate(233.763 181.445)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_7"
              data-name="Rettangolo 7"
              width="32.474"
              height="25.187"
              rx="2.333"
              transform="translate(269.394 181.445)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_8"
              data-name="Rettangolo 8"
              width="32.474"
              height="25.187"
              rx="2.333"
              transform="translate(305.025 181.445)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_9"
              data-name="Rettangolo 9"
              width="32.474"
              height="25.187"
              rx="2.333"
              transform="translate(340.656 181.445)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <text
              id="_31"
              data-name="31"
              transform="translate(134.882 194.264)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
              opacity="0.35"
            >
              <tspan x="-4.134" y="0">31</tspan>
            </text>
            <text
              id="_1"
              data-name="1"
              transform="translate(170.513 194.264)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-1.533" y="0">1</tspan>
            </text>
            <text
              id="_2"
              data-name="2"
              transform="translate(206.144 194.264)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-2.527" y="0">2</tspan>
            </text>
            <text
              id="_3"
              data-name="3"
              transform="translate(241.775 194.264)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-2.601" y="0">3</tspan>
            </text>
            <text
              id="_4"
              data-name="4"
              transform="translate(277.406 194.264)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-2.833" y="0">4</tspan>
            </text>
            <text
              id="_5"
              data-name="5"
              transform="translate(313.037 194.264)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-2.798" y="0">5</tspan>
            </text>
            <text
              id="_6"
              data-name="6"
              transform="translate(348.669 194.264)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-2.812" y="0">6</tspan>
            </text>
            <rect
              id="Rettangolo_10"
              data-name="Rettangolo 10"
              width="32.474"
              height="25.187"
              rx="2.333"
              transform="translate(126.87 209.98)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_11"
              data-name="Rettangolo 11"
              width="32.474"
              height="25.187"
              rx="2.333"
              transform="translate(162.501 209.98)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_12"
              data-name="Rettangolo 12"
              width="32.474"
              height="25.187"
              rx="2.333"
              transform="translate(198.132 209.98)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_13"
              data-name="Rettangolo 13"
              width="32.474"
              height="25.187"
              rx="2.333"
              transform="translate(233.763 209.98)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_14"
              data-name="Rettangolo 14"
              width="32.474"
              height="25.187"
              rx="2.333"
              transform="translate(269.394 209.98)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_15"
              data-name="Rettangolo 15"
              width="32.474"
              height="25.187"
              rx="2.333"
              transform="translate(305.025 209.98)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_16"
              data-name="Rettangolo 16"
              width="32.474"
              height="25.187"
              rx="2.333"
              transform="translate(340.656 209.98)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <text
              id="_7"
              data-name="7"
              transform="translate(134.882 222.799)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-2.452" y="0">7</tspan>
            </text>
            <text
              id="_8"
              data-name="8"
              transform="translate(170.513 222.799)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-2.794" y="0">8</tspan>
            </text>
            <text
              id="_9"
              data-name="9"
              transform="translate(206.144 222.799)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-2.781" y="0">9</tspan>
            </text>
            <text
              id="_10"
              data-name="10"
              transform="translate(241.775 222.799)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-4.34" y="0">10</tspan>
            </text>
            <text
              id="_11"
              data-name="11"
              transform="translate(277.406 222.799)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-3.066" y="0">11</tspan>
            </text>
            <text
              id="_12"
              data-name="12"
              transform="translate(313.037 222.799)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-4.06" y="0">12</tspan>
            </text>
            <text
              id="_13"
              data-name="13"
              transform="translate(348.669 222.799)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-4.134" y="0">13</tspan>
            </text>
            <rect
              id="Rettangolo_17"
              data-name="Rettangolo 17"
              width="32.474"
              height="25.187"
              rx="2.333"
              transform="translate(126.87 238.516)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_18"
              data-name="Rettangolo 18"
              width="32.474"
              height="25.187"
              rx="2.333"
              transform="translate(162.501 238.516)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_19"
              data-name="Rettangolo 19"
              width="32.474"
              height="25.187"
              rx="2.333"
              transform="translate(198.132 238.516)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_20"
              data-name="Rettangolo 20"
              width="32.474"
              height="25.187"
              rx="2.333"
              transform="translate(233.763 238.516)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_21"
              data-name="Rettangolo 21"
              width="32.474"
              height="25.187"
              rx="2.333"
              transform="translate(269.394 238.516)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_22"
              data-name="Rettangolo 22"
              width="32.474"
              height="25.187"
              rx="2.333"
              transform="translate(305.025 238.516)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_23"
              data-name="Rettangolo 23"
              width="32.474"
              height="25.187"
              rx="2.333"
              transform="translate(340.656 238.516)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <text
              id="_14"
              data-name="14"
              transform="translate(134.882 251.335)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-4.366" y="0">14</tspan>
            </text>
            <text
              id="_15"
              data-name="15"
              transform="translate(170.513 251.335)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-4.331" y="0">15</tspan>
            </text>
            <text
              id="_16"
              data-name="16"
              transform="translate(206.144 251.335)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-4.344" y="0">16</tspan>
            </text>
            <text
              id="_17"
              data-name="17"
              transform="translate(241.775 251.335)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-3.985" y="0">17</tspan>
            </text>
            <text
              id="_18"
              data-name="18"
              transform="translate(277.406 251.335)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-4.327" y="0">18</tspan>
            </text>
            <text
              id="_19"
              data-name="19"
              transform="translate(313.037 251.335)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-4.314" y="0">19</tspan>
            </text>
            <text
              id="_20"
              data-name="20"
              transform="translate(348.669 251.335)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-5.334" y="0">20</tspan>
            </text>
            <rect
              id="Rettangolo_24"
              data-name="Rettangolo 24"
              width="32.474"
              height="25.188"
              rx="2.333"
              transform="translate(126.87 267.052)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_25"
              data-name="Rettangolo 25"
              width="32.474"
              height="25.188"
              rx="2.333"
              transform="translate(162.501 267.052)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_26"
              data-name="Rettangolo 26"
              width="32.474"
              height="25.188"
              rx="2.333"
              transform="translate(198.132 267.052)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_27"
              data-name="Rettangolo 27"
              width="32.474"
              height="25.188"
              rx="2.333"
              transform="translate(233.763 267.052)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_28"
              data-name="Rettangolo 28"
              width="32.474"
              height="25.188"
              rx="2.333"
              transform="translate(269.394 267.052)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_29"
              data-name="Rettangolo 29"
              width="32.474"
              height="25.188"
              rx="2.333"
              transform="translate(305.025 267.052)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_30"
              data-name="Rettangolo 30"
              width="32.474"
              height="25.188"
              rx="2.333"
              transform="translate(340.656 267.052)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <text
              id="_21"
              data-name="21"
              transform="translate(134.882 279.871)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-4.06" y="0">21</tspan>
            </text>
            <text
              id="_22"
              data-name="22"
              transform="translate(170.513 279.871)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-5.054" y="0">22</tspan>
            </text>
            <text
              id="_23"
              data-name="23"
              transform="translate(206.144 279.871)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-5.128" y="0">23</tspan>
            </text>
            <text
              id="_24"
              data-name="24"
              transform="translate(241.775 279.871)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-5.36" y="0">24</tspan>
            </text>
            <text
              id="_25"
              data-name="25"
              transform="translate(277.406 279.871)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-5.325" y="0">25</tspan>
            </text>
            <text
              id="_26"
              data-name="26"
              transform="translate(313.037 279.871)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-5.339" y="0">26</tspan>
            </text>
            <text
              id="_27"
              data-name="27"
              transform="translate(348.669 279.871)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-4.979" y="0">27</tspan>
            </text>
            <rect
              id="Rettangolo_31"
              data-name="Rettangolo 31"
              width="32.474"
              height="25.188"
              rx="2.333"
              transform="translate(126.87 295.587)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_32"
              data-name="Rettangolo 32"
              width="32.474"
              height="25.188"
              rx="2.333"
              transform="translate(162.501 295.587)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_33"
              data-name="Rettangolo 33"
              width="32.474"
              height="25.188"
              rx="2.333"
              transform="translate(198.132 295.587)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_34"
              data-name="Rettangolo 34"
              width="32.474"
              height="25.188"
              rx="2.333"
              transform="translate(233.763 295.587)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_35"
              data-name="Rettangolo 35"
              width="32.474"
              height="25.188"
              rx="2.333"
              transform="translate(269.394 295.587)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_36"
              data-name="Rettangolo 36"
              width="32.474"
              height="25.188"
              rx="2.333"
              transform="translate(305.025 295.587)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <rect
              id="Rettangolo_37"
              data-name="Rettangolo 37"
              width="32.474"
              height="25.188"
              rx="2.333"
              transform="translate(340.656 295.587)"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
            <text
              id="_28"
              data-name="28"
              transform="translate(134.882 308.406)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-5.321" y="0">28</tspan>
            </text>
            <text
              id="_29"
              data-name="29"
              transform="translate(170.513 308.406)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-5.308" y="0">29</tspan>
            </text>
            <text
              id="_30"
              data-name="30"
              transform="translate(206.144 308.406)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
            >
              <tspan x="-5.409" y="0">30</tspan>
            </text>
            <text
              id="_1-2"
              data-name="1"
              transform="translate(241.775 308.406)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
              opacity="0.35"
            >
              <tspan x="-1.533" y="0">1</tspan>
            </text>
            <text
              id="_2-2"
              data-name="2"
              transform="translate(277.406 308.406)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
              opacity="0.35"
            >
              <tspan x="-2.527" y="0">2</tspan>
            </text>
            <text
              id="_3-2"
              data-name="3"
              transform="translate(313.037 308.406)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
              opacity="0.35"
            >
              <tspan x="-2.601" y="0">3</tspan>
            </text>
            <text
              id="_4-2"
              data-name="4"
              transform="translate(348.669 308.406)"
              fill="#fff"
              font-size="8.759"
              font-family="Poppins-Medium, Poppins"
              font-weight="500"
              opacity="0.35"
            >
              <tspan x="-2.833" y="0">4</tspan>
            </text>
          </g>
          <text
            id="SETTEMBRE"
            transform="translate(250 163.964)"
            fill="#fff"
            font-size="11.944"
            font-family="Nunito, Poppins-Medium, Poppins"
            font-weight="500"
            letter-spacing="0.1em"
          >
            <tspan x="-37.313" y="0">{{ mese.toUpperCase() }}</tspan>
          </text>
          <g id="Raggruppa_4" data-name="Raggruppa 4">
            <path
              id="Tracciato_4"
              data-name="Tracciato 4"
              d="M304.1,155.4l4.278,4.278-4.278,4.278"
              fill="none"
              stroke="#fff"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            />
            <path
              id="Tracciato_5"
              data-name="Tracciato 5"
              d="M195.9,155.4l-4.278,4.278,4.278,4.278"
              fill="none"
              stroke="#fff"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            />
          </g>
          <g id="Raggruppa_6" data-name="Raggruppa 6">
            <g id="Raggruppa_5" data-name="Raggruppa 5">
              <path
                id="Tracciato_6"
                data-name="Tracciato 6"
                d="M345.312,142.307a3.519,3.519,0,1,1-3.519-3.519A3.519,3.519,0,0,1,345.312,142.307Z"
                fill="#fff"
                opacity="0.9"
                style="mix-blend-mode: soft-light; isolation: isolate"
              />
              <path
                id="Tracciato_7"
                data-name="Tracciato 7"
                d="M359.221,142.307a3.52,3.52,0,1,1-3.519-3.519A3.52,3.52,0,0,1,359.221,142.307Z"
                fill="#fff"
                opacity="0.9"
                style="mix-blend-mode: soft-light; isolation: isolate"
              />
              <path
                id="Tracciato_8"
                data-name="Tracciato 8"
                d="M373.13,142.307a3.52,3.52,0,1,1-3.52-3.519A3.52,3.52,0,0,1,373.13,142.307Z"
                fill="#fff"
                opacity="0.9"
                style="mix-blend-mode: soft-light; isolation: isolate"
              />
            </g>
            <path
              id="Tracciato_9"
              data-name="Tracciato 9"
              d="M139.068,142.307a6.1,6.1,0,1,1-6.1-6.1A6.1,6.1,0,0,1,139.068,142.307Z"
              fill="#fff"
              opacity="0.9"
              style="mix-blend-mode: soft-light; isolation: isolate"
            />
          </g>
        </g>
        <g id="Raggruppa_8" data-name="Raggruppa 8">
          <g
            transform="matrix(1, 0, 0, 1, 34.78, 113.86)"
            filter="url(#Tracciato_10)"
          >
            <path
              id="Tracciato_10-2"
              data-name="Tracciato 10"
              d="M249.82,280.154a29.044,29.044,0,1,1,29.045-29.044A29.077,29.077,0,0,1,249.82,280.154Z"
              transform="translate(-34.78 -113.86)"
              fill="#fff"
            />
          </g>
          <g
            transform="matrix(1, 0, 0, 1, 34.78, 113.86)"
            filter="url(#Ellisse_1)"
          >
            <circle
              id="Ellisse_1-2"
              data-name="Ellisse 1"
              cx="19.394"
              cy="19.394"
              r="19.394"
              transform="translate(195.65 117.86)"
              fill="url(#linear-gradient-2)"
            />
          </g>
          <g
            transform="matrix(1, 0, 0, 1, 34.78, 113.86)"
            filter="url(#Tracciato_11)"
          >
            <path
              id="Tracciato_11-2"
              data-name="Tracciato 11"
              d="M256.74,243.859a48.671,48.671,0,0,0-4.47,3.46,58.788,58.788,0,0,0-6.751,6.931q-.929-.57-1.893-1.1c-.626-.342-1.263-.67-1.922-.974a21.813,21.813,0,0,0-2.039-.841c.331.677.712,1.3,1.094,1.915s.793,1.2,1.211,1.782q1.259,1.728,2.656,3.3l1.06,1.191,1.641-1.276a58.343,58.343,0,0,0,8.142-7.721,48.388,48.388,0,0,0,3.468-4.464A30.412,30.412,0,0,0,261.808,241,30.393,30.393,0,0,0,256.74,243.859Z"
              transform="translate(-34.78 -113.86)"
              fill="#fff"
            />
          </g>
        </g>
        <g id="Raggruppa_10" data-name="Raggruppa 10">
          <g
            transform="matrix(1, 0, 0, 1, 34.78, 113.86)"
            filter="url(#Rettangolo_38)"
          >
            <rect
              id="Rettangolo_38-2"
              data-name="Rettangolo 38"
              width="124.151"
              height="109.977"
              rx="14.475"
              transform="translate(247.79 196.47)"
              fill="#fff"
            />
          </g>
          <g id="Raggruppa_9" data-name="Raggruppa 9">
            <path
              id="Tracciato_12"
              data-name="Tracciato 12"
              d="M316.28,336.223h-12.8a2.653,2.653,0,0,1-2.653-2.654h0a2.653,2.653,0,0,1,2.653-2.653h12.8a2.653,2.653,0,0,1,2.653,2.653h0A2.653,2.653,0,0,1,316.28,336.223Z"
              fill="#e9ebf5"
            />
            <path
              id="Tracciato_13"
              data-name="Tracciato 13"
              d="M385.808,336.223H334.4a2.654,2.654,0,0,1-2.654-2.654h0a2.653,2.653,0,0,1,2.654-2.653h51.4a2.654,2.654,0,0,1,2.654,2.653h0A2.654,2.654,0,0,1,385.808,336.223Z"
              fill="#e9ebf5"
            />
            <path
              id="Tracciato_14"
              data-name="Tracciato 14"
              d="M316.28,348.921h-12.8a2.653,2.653,0,0,1-2.653-2.653h0a2.653,2.653,0,0,1,2.653-2.653h12.8a2.653,2.653,0,0,1,2.653,2.653h0A2.653,2.653,0,0,1,316.28,348.921Z"
              fill="#ffbd00"
            />
            <path
              id="Tracciato_15"
              data-name="Tracciato 15"
              d="M385.808,348.921H334.4a2.653,2.653,0,0,1-2.654-2.653h0a2.653,2.653,0,0,1,2.654-2.653h51.4a2.653,2.653,0,0,1,2.654,2.653h0A2.653,2.653,0,0,1,385.808,348.921Z"
              fill="#ffbd00"
            />
            <path
              id="Tracciato_16"
              data-name="Tracciato 16"
              d="M316.28,361.62h-12.8a2.653,2.653,0,0,1-2.653-2.653h0a2.653,2.653,0,0,1,2.653-2.654h12.8a2.654,2.654,0,0,1,2.653,2.654h0A2.653,2.653,0,0,1,316.28,361.62Z"
              fill="#80a7ff"
            />
            <path
              id="Tracciato_17"
              data-name="Tracciato 17"
              d="M385.808,361.62H334.4a2.653,2.653,0,0,1-2.654-2.653h0a2.654,2.654,0,0,1,2.654-2.654h51.4a2.654,2.654,0,0,1,2.654,2.654h0A2.653,2.653,0,0,1,385.808,361.62Z"
              fill="#80a7ff"
            />
            <path
              id="Tracciato_18"
              data-name="Tracciato 18"
              d="M316.28,374.319h-12.8a2.653,2.653,0,0,1-2.653-2.654h0a2.653,2.653,0,0,1,2.653-2.653h12.8a2.653,2.653,0,0,1,2.653,2.653h0A2.653,2.653,0,0,1,316.28,374.319Z"
              fill="#e9ebf5"
            />
            <path
              id="Tracciato_19"
              data-name="Tracciato 19"
              d="M385.808,374.319H334.4a2.654,2.654,0,0,1-2.654-2.654h0a2.653,2.653,0,0,1,2.654-2.653h51.4a2.654,2.654,0,0,1,2.654,2.653h0A2.654,2.654,0,0,1,385.808,374.319Z"
              fill="#e9ebf5"
            />
            <path
              id="Tracciato_20"
              data-name="Tracciato 20"
              d="M316.28,387.017h-12.8a2.653,2.653,0,0,1-2.653-2.653h0a2.653,2.653,0,0,1,2.653-2.653h12.8a2.653,2.653,0,0,1,2.653,2.653h0A2.653,2.653,0,0,1,316.28,387.017Z"
              fill="#546cff"
            />
            <path
              id="Tracciato_21"
              data-name="Tracciato 21"
              d="M385.808,387.017H334.4a2.653,2.653,0,0,1-2.654-2.653h0a2.653,2.653,0,0,1,2.654-2.653h51.4a2.653,2.653,0,0,1,2.654,2.653h0A2.653,2.653,0,0,1,385.808,387.017Z"
              fill="#546cff"
            />
            <path
              id="Tracciato_22"
              data-name="Tracciato 22"
              d="M316.28,399.716h-12.8a2.653,2.653,0,0,1-2.653-2.653h0a2.653,2.653,0,0,1,2.653-2.654h12.8a2.653,2.653,0,0,1,2.653,2.654h0A2.653,2.653,0,0,1,316.28,399.716Z"
              fill="#e9ebf5"
            />
            <path
              id="Tracciato_23"
              data-name="Tracciato 23"
              d="M385.808,399.716H334.4a2.653,2.653,0,0,1-2.654-2.653h0a2.654,2.654,0,0,1,2.654-2.654h51.4a2.654,2.654,0,0,1,2.654,2.654h0A2.653,2.653,0,0,1,385.808,399.716Z"
              fill="#e9ebf5"
            />
          </g>
        </g>
        <g id="Raggruppa_14" data-name="Raggruppa 14">
          <g
            transform="matrix(1, 0, 0, 1, 34.78, 113.86)"
            filter="url(#Ellisse_2)"
          >
            <circle
              id="Ellisse_2-2"
              data-name="Ellisse 2"
              cx="55.527"
              cy="55.527"
              r="55.527"
              transform="translate(309.12 101.81)"
              fill="url(#linear-gradient-3)"
            />
          </g>
          <path
            id="Tracciato_24"
            data-name="Tracciato 24"
            d="M432.918,304.679a47.361,47.361,0,1,1,0-66.978A47.414,47.414,0,0,1,432.918,304.679Z"
            fill="url(#linear-gradient-4)"
          />
          <path
            id="Tracciato_25"
            data-name="Tracciato 25"
            d="M432.937,237.7a47.414,47.414,0,0,0-66.978,0l66.978,66.978A47.414,47.414,0,0,0,432.937,237.7Z"
            fill="#fff"
            opacity="0.9"
            style="mix-blend-mode: soft-light; isolation: isolate"
          />
          <path
            id="Tracciato_26"
            data-name="Tracciato 26"
            d="M418.239,268.876h-16.43V245.689a2.24,2.24,0,0,0-4.479,0v25.426a2.239,2.239,0,0,0,2.24,2.239h18.669a2.239,2.239,0,1,0,0-4.478Z"
            fill="url(#linear-gradient)"
          />
          <g id="Raggruppa_13" data-name="Raggruppa 13">
            <g id="Raggruppa_11" data-name="Raggruppa 11">
              <path
                id="Tracciato_27"
                data-name="Tracciato 27"
                d="M399.429,228.931a.707.707,0,0,0-.707.706V233.5a.707.707,0,1,0,1.413,0v-3.864A.706.706,0,0,0,399.429,228.931Z"
                fill="url(#linear-gradient-6)"
              />
              <path
                id="Tracciato_28"
                data-name="Tracciato 28"
                d="M399.429,308.173a.707.707,0,0,0-.707.706v3.864a.707.707,0,1,0,1.413,0v-3.864A.706.706,0,0,0,399.429,308.173Z"
                fill="url(#linear-gradient-6)"
              />
              <path
                id="Tracciato_29"
                data-name="Tracciato 29"
                d="M361.74,270.484h-3.864a.706.706,0,1,0,0,1.413h3.864a.706.706,0,0,0,0-1.413Z"
                fill="url(#linear-gradient-8)"
              />
              <path
                id="Tracciato_30"
                data-name="Tracciato 30"
                d="M440.982,270.484h-3.864a.706.706,0,1,0,0,1.413h3.864a.706.706,0,0,0,0-1.413Z"
                fill="url(#linear-gradient-9)"
              />
              <path
                id="Tracciato_31"
                data-name="Tracciato 31"
                d="M370.546,241.308a.706.706,0,1,0-1,1l2.732,2.733a.707.707,0,0,0,1-1Z"
                fill="url(#linear-gradient-10)"
              />
              <path
                id="Tracciato_32"
                data-name="Tracciato 32"
                d="M426.578,297.341a.706.706,0,1,0-1,1l2.733,2.732a.706.706,0,0,0,1-1Z"
                fill="url(#linear-gradient-11)"
              />
              <path
                id="Tracciato_33"
                data-name="Tracciato 33"
                d="M372.279,297.341l-2.732,2.732a.706.706,0,0,0,1,1l2.732-2.732a.706.706,0,1,0-1-1Z"
                fill="url(#linear-gradient-11)"
              />
              <path
                id="Tracciato_34"
                data-name="Tracciato 34"
                d="M428.312,241.308l-2.733,2.732a.707.707,0,0,0,1,1l2.733-2.733a.706.706,0,1,0-1-1Z"
                fill="url(#linear-gradient-10)"
              />
            </g>
            <g id="Raggruppa_12" data-name="Raggruppa 12">
              <path
                id="Tracciato_35"
                data-name="Tracciato 35"
                d="M399.429,228.931a.707.707,0,0,0-.707.706V233.5a.707.707,0,1,0,1.413,0v-3.864A.706.706,0,0,0,399.429,228.931Z"
                fill="url(#linear-gradient-14)"
              />
              <path
                id="Tracciato_36"
                data-name="Tracciato 36"
                d="M399.429,308.173a.707.707,0,0,0-.707.706v3.864a.707.707,0,1,0,1.413,0v-3.864A.706.706,0,0,0,399.429,308.173Z"
                fill="url(#linear-gradient-15)"
              />
              <path
                id="Tracciato_37"
                data-name="Tracciato 37"
                d="M361.74,270.484h-3.864a.706.706,0,1,0,0,1.413h3.864a.706.706,0,0,0,0-1.413Z"
                fill="url(#linear-gradient-16)"
              />
              <path
                id="Tracciato_38"
                data-name="Tracciato 38"
                d="M440.982,270.484h-3.864a.706.706,0,1,0,0,1.413h3.864a.706.706,0,0,0,0-1.413Z"
                fill="url(#linear-gradient-17)"
              />
              <path
                id="Tracciato_39"
                data-name="Tracciato 39"
                d="M370.546,241.308a.706.706,0,1,0-1,1l2.732,2.733a.707.707,0,0,0,1-1Z"
                fill="url(#linear-gradient-18)"
              />
              <path
                id="Tracciato_40"
                data-name="Tracciato 40"
                d="M426.578,297.341a.706.706,0,1,0-1,1l2.733,2.732a.706.706,0,0,0,1-1Z"
                fill="url(#linear-gradient-19)"
              />
              <path
                id="Tracciato_41"
                data-name="Tracciato 41"
                d="M372.279,297.341l-2.732,2.732a.706.706,0,0,0,1,1l2.732-2.732a.706.706,0,1,0-1-1Z"
                fill="url(#linear-gradient-20)"
              />
              <path
                id="Tracciato_42"
                data-name="Tracciato 42"
                d="M428.312,241.308l-2.733,2.732a.707.707,0,0,0,1,1l2.733-2.733a.706.706,0,1,0-1-1Z"
                fill="url(#linear-gradient-21)"
              />
            </g>
          </g>
        </g>
        <g id="Raggruppa_20" data-name="Raggruppa 20">
          <g id="Raggruppa_19" data-name="Raggruppa 19">
            <g id="Raggruppa_18" data-name="Raggruppa 18">
              <path
                id="Tracciato_43"
                data-name="Tracciato 43"
                d="M45.107,366.454a13.613,13.613,0,0,1-9.891-14.878L44.047,271.7c2.353-19.077,15.14-29.39,28.508-25.836,9.758,2.6,15.286,14.974,16.464,24.491,1.444,11.659-4.265,19.932-7.478,30.44-2.773,9.064-6.168,17.986-9.243,26.952-4.137,12.065-6.728,17.722-10.866,29.787A13.639,13.639,0,0,1,45.107,366.454Z"
                fill="#ffc4bd"
              />
              <path
                id="Tracciato_44"
                data-name="Tracciato 44"
                d="M34.777,320.814c2.015-24.24,4.037-39.484,5.391-45,.306-1.248.624-2.843.943-4.651a33.37,33.37,0,0,1,32.14-27.631h0s8.427,24.255,6.2,33.862c0,.005-9.651,50.883-9.651,50.883C52.6,331.008,34.777,320.814,34.777,320.814Z"
                fill="#ffbd00"
              />
              <path
                id="Tracciato_45"
                data-name="Tracciato 45"
                d="M129.082,204.718c-.062-.576-5.478-11.327-5.822-13.619a47.593,47.593,0,0,0-3.742-13.556c-5.317-13.076-19.244-17.719-32.615-14.031-17.7,4.881-25.7,22.088-19.978,38.764,2.615,7.623,5.732,14.784,11.689,20.455,7.254,6.9,18.439,8.569,28.2,8.037,4.508-.246,9.083-.164,12.464-3.157,3.185-2.82,4.125-6.168,4.557-10.2.139-1.293.419-9.394,2.026-9.757C129.87,206.745,129.126,205.138,129.082,204.718Z"
                fill="#ffc4bd"
              />
              <path
                id="Tracciato_46"
                data-name="Tracciato 46"
                d="M115.808,249.109H77.78c10-10.261,7.289-23.283,7.289-23.283h27.1C109.428,234.179,115.808,249.109,115.808,249.109Z"
                fill="#ffc4bd"
              />
              <path
                id="Tracciato_47"
                data-name="Tracciato 47"
                d="M100.367,500H49.524V413.168H107.38Z"
                fill="url(#linear-gradient-22)"
              />
              <path
                id="Tracciato_48"
                data-name="Tracciato 48"
                d="M171.131,500H125.22l-14.755-15.926a133.008,133.008,0,0,1-34-70.906h70.778Z"
                fill="url(#linear-gradient-23)"
              />
              <path
                id="Tracciato_49"
                data-name="Tracciato 49"
                d="M148.53,412.447c-51.83,11.491-100.139,0-100.139,0l1.7-141.7a27.543,27.543,0,0,1,27.54-27.212h55.143S145.135,330.693,148.53,412.447Z"
                fill="url(#linear-gradient-24)"
              />
              <g id="Raggruppa_16" data-name="Raggruppa 16">
                <g id="Raggruppa_15" data-name="Raggruppa 15">
                  <path
                    id="Tracciato_50"
                    data-name="Tracciato 50"
                    d="M165.4,368.345a13.526,13.526,0,0,1-15.747-8.19l-32.411-80.022c-3.7-9.139-4.77-20.759,1.527-29.06a17.094,17.094,0,0,1,18.068-6.394c8.77,2.227,11.688,6.961,14.984,14.8,3.661,8.706,19.559,70.9,23.494,93.272A13.551,13.551,0,0,1,165.4,368.345Z"
                    fill="#ffc4bd"
                  />
                  <circle
                    id="Ellisse_3"
                    data-name="Ellisse 3"
                    cx="13.636"
                    cy="13.636"
                    r="13.636"
                    transform="translate(149.849 341.467)"
                    fill="#ffc4bd"
                  />
                  <path
                    id="Tracciato_51"
                    data-name="Tracciato 51"
                    d="M160.347,339.892s32.2-18.18,49.24-45.831L222.4,302.98s-23.7,50.832-53.533,64.655C163.534,362.257,160.347,339.892,160.347,339.892Z"
                    fill="#ffc4bd"
                  />
                </g>
                <path
                  id="Tracciato_52"
                  data-name="Tracciato 52"
                  d="M209.587,294.061l2.309-12.379a10.91,10.91,0,0,1,5.234-7.427l18.183-10.589a2.31,2.31,0,0,1,3.288,1.092h0a2.309,2.309,0,0,1-.613,2.649l-8.322,7.214a2.082,2.082,0,0,0-.093,3.06l1.634,1.6q.276.271.534.557a11.965,11.965,0,0,1-.038,15.711l-3.774,4.419a8.819,8.819,0,0,1-5.528,3.013h0Z"
                  fill="#ffc4bd"
                />
              </g>
              <g id="Raggruppa_17" data-name="Raggruppa 17">
                <path
                  id="Tracciato_53"
                  data-name="Tracciato 53"
                  d="M127.793,160.692c-4.583-10.406-18.373-5.739-26.048-2.635a33.684,33.684,0,0,1-10.819,2.907c-5.3.32-10.348-.059-15.263,2.3A25.65,25.65,0,0,0,64.75,173.311c-4.466,7.589-5.036,17.1-2.627,25.566,1.572,5.528,4.881,10.278,8.316,14.8,3.168,4.171,5.741,9.39,10.562,11.916,8.378,4.389,20.592-2.535,22.358-11.547a12.039,12.039,0,0,0-3.414-3.485,6.774,6.774,0,0,1-2.38-2.995c-1.31-3.176-.112-6.683,2.676-7.833s6.111.492,7.421,3.668a6.88,6.88,0,0,1,.339,1.052,2.806,2.806,0,0,0,2.657,2.258c3.829-.016,2.07-7.378,1.587-11.591-.457-3.992-.384-7.8,2.129-11.205,3.94-5.347,10.091-8.661,13.1-14.668A10.7,10.7,0,0,0,127.793,160.692Z"
                  fill="#000042"
                />
                <circle
                  id="Ellisse_4"
                  data-name="Ellisse 4"
                  cx="1.324"
                  cy="1.324"
                  r="1.324"
                  transform="translate(118.967 194.493)"
                  fill="#000042"
                />
                <path
                  id="Tracciato_54"
                  data-name="Tracciato 54"
                  d="M122.621,187.3a10.633,10.633,0,0,0-7.1,3.651,2.308,2.308,0,0,0-.472.694.939.939,0,0,0,.178,1,.9.9,0,0,0,.758.177,2.665,2.665,0,0,0,.748-.293,19.624,19.624,0,0,1,6.368-2.46Z"
                  fill="#000042"
                />
                <path
                  id="Tracciato_55"
                  data-name="Tracciato 55"
                  d="M122.723,215.14a5.089,5.089,0,0,1-3.932-2.119l.708-.468a3.951,3.951,0,0,0,4.758,1.423l-.121.948A4.9,4.9,0,0,1,122.723,215.14Z"
                  fill="#e49389"
                />
              </g>
              <path
                id="Tracciato_56"
                data-name="Tracciato 56"
                d="M169.511,315.419c-5.788-23.625-14.15-51.3-16.351-56.538-3.295-7.837-6.214-12.571-14.983-14.8-6.884-1.747-16.175.748-20.458,6.394-6.3,8.3-5.228,19.921-1.527,29.06,0,.006,17.506,48.743,17.506,48.743C151.12,328.28,169.511,315.419,169.511,315.419Z"
                fill="#ffbd00"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
import { MESI } from "../../libs/utils/commons";
export default {
  name: "BenvenutoImg",
  computed: {
    mese: function () {
      const data = new Date();
      return MESI[data.getMonth() + 1];
    },
  },
};
</script>

<style lang="scss" scoped></style>
